export default function Telefon(props) {
	return (
		<a href={"tel:" + props.children.replace(/\s+/g, "")}>
			<span id="a11y-telefon">
				<strong>{props.children}</strong>
			</span>
		</a>
	);
}
